module.exports = __webpack_public_path__ + "static/media/ADI-Cover-Art.bf2ade48.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ADI-Cover-Art.png
// module id = 2571
// module chunks = 0